import React from 'react';
import { Label, Input } from 'semantic-ui-react';

/**
 * @param {boolean} edit Habilita ou nao o modo de edicao
 * @param {*} value Valor a ser exibido/editado
 */
const EditableLabel = ({ edit, value, ...rest }) => {
    return edit ? (
        <Input value={value} {...rest} />
    ) : (
        <Label size='large' className='fluid'>{value}</Label>
    );
}

export default EditableLabel;


// WEBPACK FOOTER //
// ./src/components/EditableLabel.js